import vuetify from '@/plugins/vuetify';
import snackbar from './snackbar.vue';

let prevPromise = null;
let promisePending = false;
let prevMessage = '';

export default {
  install(Vue) {
    const $snackbar = (snackMessage, snackColor, snackDuration) => {
      const showSnackbar = (resolve, reject) => {
        try {
          promisePending = true;
          const props = {
            snackMessage, snackColor, snackDuration, isVisible: true,
          };
          const on = {};
          const comp = new Vue({
            vuetify,
            render: (h) => h(snackbar, { props, on }),
          });
          on.dismissed = () => {
            resolve();
            window.setTimeout(() => comp.$destroy(), 100);
          };
          comp.$mount();
          document.querySelector('#app .v-application--wrap').appendChild(comp.$el);
        } catch (err) {
          reject(err);
        }
      };

      if (prevPromise !== null && promisePending) {
        if (prevMessage !== snackMessage) {
          return prevPromise.then(() => {
            const promise = new Promise(showSnackbar).finally(() => {
              promisePending = false;
            });
            prevPromise = promise;
            return promise;
          });
        } else {
          return prevPromise;
        }
      }

      const promise = new Promise(showSnackbar).finally(() => {
        promisePending = false;
      });
      prevPromise = promise;
      prevMessage = snackMessage;
      return promise;
    };

    Vue.prototype.$snackbar = $snackbar;
  },
};
